import { Link } from "react-router-dom";
import { Bell, CalendarDays, StickyNote } from "lucide-react";
import { spaceOf } from "@/lib/spaces";
import { daysLeft, fmtDay, projectProgress } from "@/lib/time";
import { SpaceAvatar } from "@/components/SpaceAvatar";
import { statusOf } from "@/components/StatusPicker";

export const ProgressBar = ({ value, color }) => (
  <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]">
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${value}%`, background: color }} />
  </div>
);

export const DaysLeft = ({ p }) => {
  const d = daysLeft(p);
  if (d == null) return null;
  const cls = d < 0 ? "text-red-400" : d <= 2 ? "text-amber-400" : "text-muted-foreground";
  return <span className={`font-mono text-xs ${cls}`}>{d < 0 ? `${-d}d overdue` : d === 0 ? "due today" : `${d}d left`}</span>;
};

export const ProjectCard = ({ p }) => {
  const s = spaceOf(p.space);
  const st = statusOf(p.status);
  const pct = projectProgress(p);
  return (
    <Link to={`/projects/${p.id}`} data-testid={`project-card-${p.id}`}
      className="group flex flex-col rounded-2xl border bg-card/70 p-5 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-white/20">
      <div className="flex items-center justify-between">
        <span className="rounded-full px-2.5 py-0.5 text-[11px] font-semibold" style={{ background: `${st.color}1f`, color: st.color }}>{st.label}</span>
        <SpaceAvatar space={p.space} />
      </div>
      <h3 className="mt-4 font-display text-lg font-semibold leading-snug tracking-tight">{p.title}</h3>
      {p.description && <p className="mt-1.5 line-clamp-2 text-sm text-muted-foreground">{p.description}</p>}
      <div className="mt-auto pt-5">
        {pct != null && <ProgressBar value={pct} color={s.color} />}
        <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
          {p.end_date && <span className="flex items-center gap-1"><CalendarDays className="h-3 w-3" /> {fmtDay(p.end_date)}</span>}
          <DaysLeft p={p} />
          <span className="ml-auto flex items-center gap-3">
            <span className="flex items-center gap-1"><Bell className="h-3 w-3" /> {p.open_reminders ?? 0}</span>
            <span className="flex items-center gap-1"><StickyNote className="h-3 w-3" /> {p.notes_count ?? 0}</span>
          </span>
        </div>
      </div>
    </Link>
  );
};
